import React from "react";
import { LoginScreenWithAuthData } from "~/features/login/LoginScreen";

const Component = () => {
  return <LoginScreenWithAuthData />;
};

export default Component;
